import FixaSSRIcon from "../../../shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import ArrowRightSmallIconPath from "../../../shared/wrappers/FixaSSRIcon/paths/ArrowRightSmallIconPath";
import { ComponentNotificationBodyAssignedTitle } from "./types/task-notification.types";
import styles from "./task-notification.module.css";
import { getBodyAssignerString } from "./utils/task-notification-body";

interface TaskNotificationBodyAssignedTitleProps extends ComponentNotificationBodyAssignedTitle {
  read: boolean;
}
export const TaskNotificationBodyAssignedTitle = ({
  props: { title, oldAssignedTo, newAssignedTo },
}: TaskNotificationBodyAssignedTitleProps) => {
  const oldAssignedToString = getBodyAssignerString(oldAssignedTo);
  const newAssignedToString = getBodyAssignerString(newAssignedTo);
  return (
    <div className={styles["task-notification-item-body"] ?? ""}>
      <div className={styles["task-notification-item-body-texts"] ?? ""}>
        {!!title && (
          <div className={styles["task-notification-item-body-title"] ?? ""}>
            {title}
          </div>
        )}
        {!!oldAssignedToString && !!newAssignedToString && (
          <div>
            <span
              className={
                styles["task-notification-item-body-old-assigned"] ?? ""
              }
            >
              {oldAssignedToString}
            </span>
            <FixaSSRIcon paths={ArrowRightSmallIconPath} />
            <span>{newAssignedToString}</span>
          </div>
        )}
      </div>
    </div>
  );
};
